import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseQueryWithAuth } from "../shared/baseQuery"; 

export const userSlice = createApi({
    reducerPath: 'user',
    baseQuery: baseQueryWithAuth,
    endpoints: builder => ({
        getUserFeatures: builder.query({
            query: () => `/account/feature`,
        })
    })
})

export const {
    useGetUserFeaturesQuery
} = userSlice